/**
 * SIL-1648: an asset row can be a stock line (quantity > 1). Counts that
 * come as units plus lines read "N units in M lines" only when the two
 * differ, so a fleet of serialized units stays plain.
 */
export function unitsInLinesText(units: number, lines: number | null | undefined): string | null {
  if (lines == null || lines === units) return null;
  const u = `${units.toLocaleString()} ${units === 1 ? 'unit' : 'units'}`;
  const l = `${lines.toLocaleString()} ${lines === 1 ? 'line' : 'lines'}`;
  return `${u} in ${l}`;
}
